import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import SouthOutlinedIcon from '@mui/icons-material/SouthOutlined';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import './Accordion.css';
import { QevoltData } from '../../../components/Qevolt-data/QevoltData';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<SouthOutlinedIcon sx={{ fontSize: '1.5rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#FDFBF9' : '#FDFBF9',
  flexDirection: 'row',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(-180deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.mode === 'dark' ? '#FDFBF9' : '#FDFBF9',
  // borderTop: '0px solid rgba(0, 0, 0, .125)',
}));

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState('panel1');
  const { AccordionData } = QevoltData();
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      {AccordionData.map((val) => (
        <Accordion className = "accordion"
          expanded={expanded === val.panel}
          onChange={handleChange(val.panel)}
        >
          <AccordionSummary aria-controls='panel2d-content' id='panel2d-header'>
            <Typography>
              <div className='accordion-main-text'>{val.title}</div>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className='accordion-inner-text'>{val.description}</div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
